import * as React from "react";
import {Tab, TabLink, TabList, Tabs} from "bloomer";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import CodeExamples from "./CodeExamples";

interface IAPIDocsProps {
    modelName: string;
}

interface IAPIDocsState {
    activeTabName: string;
}

class APIDocs extends React.Component<IAPIDocsProps, IAPIDocsState> {
    public TAB_NAMES = {
        HTTP: "HTTP",
        PYTHON: "Python"
    };

    constructor(props: IAPIDocsProps) {
        super(props);

        this.state = {
            activeTabName: this.TAB_NAMES.HTTP
        };
    }

    public render() {
        return <React.Fragment>
            <Tabs>
                <TabList isAlign="center" style={{borderBottomStyle: 'none'}}>
                    <Tab isActive={this.state.activeTabName === this.TAB_NAMES.HTTP}>
                        <TabLink onClick={() => {
                            this.setState({activeTabName: this.TAB_NAMES.HTTP});
                        }}>
                            <span>{this.TAB_NAMES.HTTP}</span>
                        </TabLink>
                    </Tab>
                    <Tab isActive={this.state.activeTabName === this.TAB_NAMES.PYTHON}>
                        <TabLink onClick={() => {
                            this.setState({activeTabName: this.TAB_NAMES.PYTHON});
                        }}>
                            <span>{this.TAB_NAMES.PYTHON}</span>
                        </TabLink>
                    </Tab>
                </TabList>
            </Tabs>
            <ModelContentContainer>
                {
                    this.state.activeTabName === this.TAB_NAMES.HTTP ? <CodeExamples
                        modelName={this.props.modelName}
                        language={this.TAB_NAMES.HTTP}
                        codeClass="language-http"
                    /> : <></>
                }
                {
                    this.state.activeTabName === this.TAB_NAMES.PYTHON ? <CodeExamples
                        modelName={this.props.modelName}
                        language={this.TAB_NAMES.PYTHON}
                        codeClass="language-python"
                    /> : <></>
                }
            </ModelContentContainer>
        </React.Fragment>;
    }
}

export default APIDocs;


// WEBPACK FOOTER //
// ./src/components/model/APIDocs/index.tsx